import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { concatWithDot } from 'helpers/string';

import { IMonthlySalesPlanField } from './types';

export const MonthlySalesPlanField: FC<IMonthlySalesPlanField> = ({ name }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const monthlySalesPlanMonetaryValue = useWatch({
    name: [
      concatWithDot(name, PRODUCT_NAMES.PRICE),
      concatWithDot(name, PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL),
    ],
  })
    .map(Number)
    .reduce((total, current) => total * current, 1);

  return (
    <NumberInputControlled
      control={control}
      id={concatWithDot(name, PRODUCT_NAMES.MONTHLY_SALES_PLAN_MONETARY)}
      name={concatWithDot(name, PRODUCT_NAMES.MONTHLY_SALES_PLAN_MONETARY)}
      label={t('global.products.monthlySalesPlan', { units: t('monetary') })}
      adornmentType="currency"
      value={monthlySalesPlanMonetaryValue}
      disabled
    />
  );
};
